import front from './front.png';
import page4_5 from './handprint-4-5-page.png';
import page6_7 from './handprint-6-7-page.png';
import page8_9 from './handprint-8-9-page.png';
import page10_11 from './handprint-10-11-page.png';
import page12_13 from './handprint-12-13-page.png';
import page14_15 from './handprint-14-15-page.png';
import page16_17 from './handprint-16-17-page.png';
import page18_19 from './handprint-18-19-page.png';
import page20_21 from './handprint-20-21-page.png';
import page22_23 from './handprint-22-23-page.png';
import page24_25 from './handprint-24-25-page.png';
import page26_27 from './handprint-26-27-page.png';
import page28_29 from './handprint-28-29-page.png';
import page30_31 from './handprint-30-31-page.png';
import page32_33 from './handprint-32-33-page.png';
import page34_35 from './handprint-34-35-page.png';
import page36 from './handprint-36-page.png';

const imageMap = {
  'front.png': front,
  'handprint-4-5-page.png': page4_5,
  'handprint-6-7-page.png': page6_7,
  'handprint-8-9-page.png': page8_9,
  'handprint-10-11-page.png': page10_11,
  'handprint-12-13-page.png': page12_13,
  'handprint-14-15-page.png': page14_15,
  'handprint-16-17-page.png': page16_17,
  'handprint-18-19-page.png': page18_19,
  'handprint-20-21-page.png': page20_21,
  'handprint-22-23-page.png': page22_23,
  'handprint-24-25-page.png': page24_25,
  'handprint-26-27-page.png': page26_27,
  'handprint-28-29-page.png': page28_29,
  'handprint-30-31-page.png': page30_31,
  'handprint-32-33-page.png': page32_33,
  'handprint-34-35-page.png': page34_35,
  'handprint-36-page.png': page36,
};

export { page36, front };

export function replaceHandprintBgImages(html) {
  if (!html) return html;
  let result = html;
  Object.entries(imageMap).forEach(([filename, url]) => {
    const placeholder = '/assets/handprint/' + filename;
    // replaces both CSS url() and <img src> occurrences
    result = result.split(placeholder).join(url);
  });
  return result;
}
